/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { Button } from '@zapier/design-system';

type Props = {
  href?: string;
  onClick?: () => void;
};

export const UpgradeButton = ({ href, onClick }: Props) =>
  onClick ? (
    <Button hasShadow={true} key="upgrade" onClick={onClick}>
      Upgrade
    </Button>
  ) : (
    <Button hasShadow={true} href={href} key="upgrade">
      Upgrade
    </Button>
  );
